<template>
    <div class="row">
       <div class="mx-auto col-md-12">               
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <b-card
                        class="mb-2"
                        header="Arquivo para criação de contas"
                        header-tag="header">
                        <div class="p-0 row mb-3">                 
                            <div class="col-12 text-center">
                                <b-button                      
                                    variant="primary"                   
                                    @click.prevent="exportarCSV">
                                        <font-awesome-icon                                                                      
                                            :icon="['fas','file-csv']"
                                            class="mr-1"
                                        />
                                        Exportar para CSV
                                </b-button>
                            </div>
                        </div>   
                    </b-card>           
                </div>
            </div>            
       </div>
    </div>
</template>

<script>

export default {
    methods: {
        exportarCSV(){
            this.$api.get(`familias/exportar/arquivo-criacao-conta`, {responseType: 'blob'})
                .then(response => {  
                    this.$helpers.downloadFile(response.data,'abertura_de_conta.csv');
                    this.$helpers.showToast(this, 'Sucesso', 'Arquivo gerado com sucesso.','success');                   
                })
                .catch( () => {                                            
                    this.$helpers.showToast(this,'Erro', 'Erro na geração do arquivo', 'danger');                                            
                }); 
        },
    },
}

</script>

<style scoped>

</style>
